import React from 'react';

import classNames from 'classnames';
import ThreeDotsIcon from 'icons/three-dots.svg';
import PropTypes from 'prop-types';

export default function OptionsToggle({
  buttonRef,
  isOptionsDropdownVisible,
  onClick,
  threeDotsIconClassName,
}) {
  return (
    <button
      className={classNames(
        'tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-0',
        isOptionsDropdownVisible ?
          'tw-border-1 tw-border-solid tw-border-blue-100 tw-bg-white'
        : 'hover:tw-bg-blue-050',
      )}
      data-element-name='options-toggle'
      onClick={onClick}
      ref={buttonRef}
    >
      <ThreeDotsIcon
        className={classNames(
          '[&_path]:tw-fill-grey-500',
          threeDotsIconClassName,
        )}
        width={12}
      />
      <span className='tw-sr-only'>Options</span>
    </button>
  );
}

OptionsToggle.propTypes = {
  isOptionsDropdownVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonRef: PropTypes.func.isRequired,
  threeDotsIconClassName: PropTypes.string,
};
